const PUSH_LAST_FULL_PAGE_ROUTE_NAME = (state, payload) => {
    state.routeName = payload;
};

export default {
    PUSH_LAST_FULL_PAGE_ROUTE_NAME,
};
